import { Typography } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import React, { useEffect, useState } from "react";

interface TimerCounterProps {
  startDate?: Dayjs;
  endDate?: Dayjs;
  daysReturn:boolean;
  finishDate: Dayjs | null
}

export const TimerCounterSla = ({endDate,startDate,daysReturn,finishDate}:TimerCounterProps) => {
  const [timeDiff, setTimeDiff] = useState("00:00:00");
  const [timeDiffWithDays, setTimeDiffWithDays] = useState("00 días 00:00:00");

  useEffect(() => {
    const updateTime = () => {
      const now = dayjs();
      let diffSeconds = 0;

      if (finishDate) {
        // Si finishDate existe, calcular desde startDate hasta finishDate
        if (startDate && !endDate) {
          diffSeconds = Math.floor(finishDate.diff(startDate) / 1000);
        } else if (endDate) {
          //diffSeconds = 0;
          /* const diffFirst = Math.floor(finishDate.diff(startDate) / 1000);
          const diffSecond = Math.floor(endDate.diff(finishDate) / 1000); */
          diffSeconds = Math.floor(endDate.diff(finishDate) / 1000);
        }
      } else {
        // Si no hay finishDate, continuar con la lógica normal
        if (startDate && !endDate) {
          diffSeconds = now.diff(startDate, "second");
        } else if (endDate) {
          if( now.isAfter(startDate)){
            diffSeconds = Math.floor(endDate.diff(now) / 1000);
          } else{
            diffSeconds = Math.floor(endDate.diff(startDate) / 1000);
          }
          
        }
      }

      diffSeconds = Math.max(diffSeconds, 0);

      const days = Math.floor(diffSeconds / 86400).toString().padStart(2,"0")
      let hours = Math.floor((diffSeconds % 86400) / 3600).toString().padStart(2, "0");
      const minutes = Math.floor((diffSeconds % 3600) / 60).toString().padStart(2, "0");
      const seconds = (diffSeconds % 60).toString().padStart(2, "0");

      if (endDate && !now.isSame(endDate, "day")) {
        hours = String( Number(hours) + Number(days) * 24 );
      }

      setTimeDiff(`${hours}:${minutes}:${seconds}`);
      setTimeDiffWithDays(`${days} días ${hours}:${minutes}:${seconds}`);
    };

    updateTime(); // Llamada inicial
    const intervalId = setInterval(updateTime, 1000);

    return () => clearInterval(intervalId);
  }, [startDate, endDate]);

  return <Typography color="textSecondary" sx={{fontWeight:'bold'}}>{daysReturn ? timeDiffWithDays : timeDiff}</Typography>;
};